import React, { Component } from "react";
import { Trans, translate } from "react-i18next";
import compose from "ramda/src/compose";
import { connect } from "react-redux";
import { Modal, Button, Timer } from "shared/components";
import IconRepair from "../../../../assets/svg/icone-reparo-modal.svg";
import styles from "./styles.css";
import { repairAutomatically } from "services/state/actions";

class ModalAutoFixCounter extends Component {
  componentDidMount() {
    // const promise = new Promise(()=>{

    // })

    // promise
    //   .then(()=> {
    //     console.log('repairAutomatically success')
    //   })
    //   .catch(()=> {
    //     console.log('repairAutomatically catch')
    //   })

    this.props.repairAutomatically(
      this.props.wizard.product,
      this.handleRepairFail,
      this.handleRepairSuccess
    );
  }

  handleRepairFail = () => {
    console.log("handleRepairFail");
  };

  handleRepairSuccess = () => {
    console.log("handleRepairSuccess");
  };

  render() {
    const { t, isCurrentStep, onPreviousStep } = this.props;
    return (
      <Modal
        isOpen={isCurrentStep}
        onClose={onPreviousStep}
        title={t("MSG_0194")}
        icon={IconRepair}
        ariaHideApp={false}
      >
        <div className={styles.root}>
          <Timer time={0} duration={240}></Timer>
          <p>
            <Trans i18nKey="MSG_0197">
              <br />
            </Trans>
          </p>
          <div className={styles.action}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ({ repair, wizard }) => ({
  repair,
  wizard,
});

const enhance = compose(
  translate(),
  connect(mapStateToProps, { repairAutomatically })
);

export default enhance(ModalAutoFixCounter);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalAutoFixCounter/index.js